import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { apiPayments } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
// import { payments as paymentsLayout } from 'constants/layout'

@apiPayments()
@withRouter
class Payments extends Component {
  static propTypes = {
    children: PropTypes.any,
    route: PropTypes.object
    // tabs: PropTypes.any.isRequired
  }

  render() {
    const {
      // tabs,
      children,
      route
    } = this.props
    // const links = paymentsLayout.tabs

    return (
      <div>
        {/* {React.cloneElement(tabs, {
          links
        })} */}
        {children
          ? React.cloneElement(children, this.props)
          : renderRoutes(route.routes, this.props)
        }
      </div>
    )
  }
}

export default Payments
